export const acceptGalleryImages = '.png,.jpg,.jpeg';
